import React, {KeyboardEvent, useCallback} from 'react';

import EntrySearchInput from 'notebook/entries/EntrySearchInput';
import {maybeGetValueFromConfig} from 'pipelines/generalized-step-config-editor/step-config-settings/StepConfigSettingsUtils';
import {CustomComponentEditorProps} from 'pipelines/generalized-step-config-editor/StepConfigEditorTypes';
import {SearchContext} from 'search/SearchConstants';

function blurOnEnter(e: KeyboardEvent<HTMLElement>): void {
  if (e.key === 'Enter') {
    e.preventDefault();
    e.currentTarget.blur();
  }
}

export default function EntryEditor({
  config,
  onChangeConfig,
  disabled,
}: CustomComponentEditorProps): JSX.Element {
  const selectedEntryId =
    (maybeGetValueFromConfig(config, ['documentId']) as string | null | undefined) ?? null;

  const handleChange = useCallback(
    (entries: Array<{id?: string | null}>) => {
      onChangeConfig(config, ['documentId'], entries[0]?.id ?? null);
    },
    [config, onChangeConfig]
  );

  return (
    <EntrySearchInput
      selectedEntries={selectedEntryId != null ? [{id: selectedEntryId}] : []}
      onChange={handleChange}
      shouldAllowMultiple={false}
      autoFocus={false}
      onKeyDown={blurOnEnter}
      placeholder="Select entry"
      context={SearchContext.FOR_WRITE_ACTION}
      disabled={Boolean(disabled)}
    />
  );
}
